import jwt from '@/http/requests/auth/jwt'

export default {

  fetchVouchers ({ commit }, idOrganisation) {
    return new Promise((resolve, reject) => {
      jwt.get('/api/admin/voucher/list', { idOrganisation })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchVoucher (context, campaignId) {
    return new Promise((resolve, reject) => {
      const url = campaignId ? `/api/admin/voucher/${campaignId}` : "/api/admin/voucher/new"
      jwt.get(url)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addVoucher (context, data) {
    return new Promise((resolve, reject) => {
      jwt.post('/api/admin/voucher/save', data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  saveVoucher (context, updatedData) {
    return new Promise((resolve, reject) => {
      jwt.get(`/api/admin/voucher/${updatedData.id}`)
        .then((response) => {
          const data = response.data.voucher
          Object.assign(data, updatedData)
          jwt.post('/api/admin/voucher/save', data)
            .then((response) => {
              resolve(response)
            })
            .catch((error) => { reject(error) })
        }).catch((error) => { reject(error) })

    })
  },
  removeRecord ({ commit }, id) {
    return new Promise((resolve, reject) => {
      jwt.post(`/api/admin/voucher/delete/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchVoucherUsers ({ commit }, idVoucher) {
    return new Promise((resolve, reject) => {
      jwt.get('/api/admin/voucheruser/list', { idVoucher: idVoucher })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUnmappedUsers ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt.get(`/api/admin/voucher/${payload.idVoucher}/users/unmapped`, { idOrganisation: payload.idOrganisation })
        .then((response) => {
          commit('SET_UNMAPPED_USERS', response.data.items)
          resolve(response.data.items)
        })
        .catch((error) => { reject(error) })
    })
  },
  saveVoucherUser (context, updatedData) {
    return new Promise((resolve, reject) => {
      jwt.get(`/api/admin/voucheruser/${updatedData.id}`)
        .then((response) => {
          const data = response.data.voucherUser
          Object.assign(data, updatedData)
          jwt.post('/api/admin/voucheruser/save', data)
            .then((response) => {
              resolve(response)
            })
            .catch((error) => { reject(error) })
        }).catch((error) => { reject(error) })

    })
  },
  addVoucherUsers (context, payload) {
    return jwt.post(`/api/admin/voucher/${payload.id}/users/add`, payload)
  },
  inviteVoucherUser (context, payload) {
    return jwt.post(`/api/admin/organisationuser/invite`, payload)
      .then((response) => {
        const payloadAdd = {
          id: payload.idVoucher,
          idOrganisation: payload.idOrganisation,
          customerIds: [response.data.organisationUser.idCustomer],
          idRole: payload.idRole
        }
        return jwt.post(`/api/admin/voucher/${payload.idVoucher}/users/add`, payloadAdd)
      })
  },
  deleteVoucherUser (context, id) {
    return jwt.post(`/api/admin/voucheruser/delete`, { id })
  },
}
